import { render } from "./model-select-from-db.html?vue&type=template&id=4cc6287c&scoped=true&ts=true"
import script from "./model-select-from-db.ts?vue&type=script&lang=ts"
export * from "./model-select-from-db.ts?vue&type=script&lang=ts"

import "./model-select-from-db.scss?vue&type=style&index=0&id=4cc6287c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc6287c"]])

export default __exports__